import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCollectionsQuery = createQueryHook(CollectionsApiClient.getCollections, {
  queryKey: ['collections'],
})
